import * as React from 'react';
import Svg, { SvgProps, Rect, Path } from 'react-native-svg';

interface Props extends SvgProps {
  checkcolor?: string,
  unselected?: boolean,
}

const CheckBox = (props: Props) => <Svg
  width={16}
  height={16}
  fill='none'
  {...props}
>
  {!props.unselected && <Path
    d='m3.333 7.999 3.333 3.333 6-6'
    stroke={props.checkcolor ?? '#0058AD'}
    strokeWidth={1.5}
    strokeLinecap='round'
    strokeLinejoin='round'
  />}
  <Rect
    x={0.5}
    y={0.5}
    width={15}
    height={15}
    rx={2.5}
    stroke={props.color ?? '#0058AD'}
  />
</Svg>;

export default CheckBox;
